import React from "react";
import "./StepItem.css";
import { checkkmark } from "../../../../images/TeleBindingImages/TeleBindingImages";

const StepItem = ({ icon, text, done }) => {
  return (
    <div className="steps">
  <ol>
    <li>
      <div className="step-info">
        <img src={icon} alt="step icon" className="step-icon-img" />
        <p>{text}</p>
      </div>
     {done && (
            <img
              src={checkkmark}
              alt="checkmark-icon"
              className="checkmark-icn"
            />
          )}
    </li>
  </ol>
</div>
  );
};

export default StepItem;
